import React from 'react';
import PropTypes from 'prop-types';
import {motion, AnimatePresence} from 'motion/react';
import {CircularProgress} from '@tenancy.nz/ui';

const fadeEnd = {
  scale: 1,
  translateY: 1,
  opacity: 1,
};

const fadeStart = {
  scale: 0.99,
  translateY: -5,
  opacity: 0,
};

function PageLoader({show}) {
  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={fadeStart}
          animate={fadeEnd}
          exit={fadeStart}
          transition={{
            duration: 0.1,
            ease: 'easeOut',
          }}
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            bottom: 0,
            background: 'rgba(255,255,255,0.7)',
            zIndex: 100,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}>
          <CircularProgress size={200} thickness={1} />
        </motion.div>
      )}
    </AnimatePresence>
  );
}

PageLoader.propTypes = {
  show: PropTypes.bool,
};

PageLoader.defaultProps = {
  show: false,
};

export default PageLoader;
